<div class="layout-content">
	<form (ngSubmit)="submit()" [formGroup]="exportForm">
		<div class="grid">
			<div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.name, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'label')">{{ 'NAME_LIST_DEVICE_DATAS' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.name, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="scenery-add-input-name"
							formControlName="name" autocomplete="scenery-name" placeholder="{{ 'NAME_LIST' | translate }}"
							maxlength="26" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.name)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate
					}}</small>
			</div>
			<!-- <div class="col-12" [ngClass]="customPaddingX()">
				<div class="flex justify-content-between flex-wrap"
					[ngClass]="newShowErrors(this.f.description, 'borderRow')">
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'label')">{{ 'DESCRIPTION_LIST' | translate }}</div>
					<div class="flex align-items-center justify-content-center"
						[ngClass]="newShowErrors(this.f.description, 'borderInput')">
						<input type="text" pInputText [ngClass]="dynamicInputTextWidth()" id="scenery-add-input-name"
							formControlName="description" autocomplete="scenery-description"
							placeholder="{{ 'DESCRIPTION' | translate }}" maxlength="26" />
					</div>
				</div>
				<small *ngIf="showErrorRequiredMessage(this.f.description)" class="flex align-items-center text-50 pt-1"
					[ngClass]="justifyContentStyle()">{{ 'REQUIRED' | translate }}. {{ 'INSERT_ATLEAST_5CHARS' | translate
					}}</small>
			</div> -->
		</div>

		<div class="grid mt-5 mx-1 flex justify-content-center align-items-center">
			<button type="submit" pButton pRipple label="{{ 'CONFIRM' | translate }}"
				class="p-button-primary text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
			<button type="button" pButton pRipple (click)="closeDialog()" label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-2 mb-1" [ngClass]="dynamicButtonWidth()">
			</button>
		</div>
	</form>
</div>